import { render } from "./DocumentProcessList.vue?vue&type=template&id=0beb7f0a&ts=true"
import script from "./DocumentProcessList.vue?vue&type=script&lang=ts"
export * from "./DocumentProcessList.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__